<template>
  <div class="home">
    <v-col class="pt-5">
      <div class="d-flex" v-if="false">
        <v-btn depressed color="primary" @click="dialogAddress = true"
          >Address</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="dialogCourier = true"
          class="ml-3"
          >Courier</v-btn
        >
      </div>
      <div class="pt-3 pb-5">
        <v-carousel
          light
          cycle
          hide-delimiter-background
          show-arrows-on-hover
          class="rounded-lg slider-h-100"
          v-if="banner.length == 0"
        >
          <v-carousel-item v-for="(slide, i) in slides" :key="i">
            <v-sheet>
              <v-row align="center" justify="center">
                <v-img eager :src="slide"></v-img>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <v-carousel
          light
          cycle
          hide-delimiter-background
          show-arrows-on-hover
          class="rounded-lg slider-h-100"
          v-else
        >
          <v-carousel-item
            v-for="(data, i) in banner"
            :key="i"
            @click="redirectTo(data.banner_url)"
          >
            <v-sheet>
              <v-row class="fill-height" align="center" justify="center">
                <v-img eager :src="data.banner_image"></v-img>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </div>
      <saldo-preview v-if="isAuth" />
      <!-- <v-row>
        <v-col md="8" class="pt-3 pb-5">
          <v-carousel
            light
            cycle
            hide-delimiter-background
            show-arrows-on-hover
            class="rounded-lg slider-h-100"
            v-if="banner.length == 0"
          >
            <v-carousel-item v-for="(slide, i) in slides" :key="i">
              <v-sheet>
                <v-row align="center" justify="center">
                  <v-img eager :src="slide"></v-img>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
          <v-carousel
            light
            cycle
            hide-delimiter-background
            show-arrows-on-hover
            class="rounded-lg slider-h-100"
            v-else
          >
            <v-carousel-item
              v-for="(data, i) in banner"
              :key="i"
              @click="redirectTo(data.banner_url)"
            >
              <v-sheet>
                <v-row class="fill-height" align="center" justify="center">
                  <v-img eager :src="data.banner_image"></v-img>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-col>
        <v-col md="4">
          <v-row class="px-0 pb-1 pt-0">
            <v-col cols="6" md="12" class="px-md-0 pb-3 pt-0">
              <v-img class="rounded-lg" src="/assets/banner/mini-1.jpeg" />
            </v-col>
            <v-col cols="6" md="12" class="px-md-0 pb-1 pt-0">
              <v-img class="rounded-lg" src="/assets/banner/mini-2.png" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>-->

      <!-- <div class="py-5">
        <v-card elevation="0" light class="rounded-lg bg-dark white--text">
          <v-col cols="12">
            <v-row>
              <v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
                <v-row>
                  <v-col cols="3" class="my-auto py-0">
                    <v-img src="/assets/icons/layanan-24-jam-icon.svg"></v-img>
                  </v-col>
                  <v-col cols="9" class="my-auto py-0">
                    <div class="text-subtitle-2">Layanan 24/7</div>
                    <div class="text-caption">Tim Support Handal dan Cepat untuk Anda</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
                <v-row>
                  <v-col cols="3" class="my-auto py-0">
                    <v-img src="/assets/icons/layanan-cepat-icon.svg"></v-img>
                  </v-col>
                  <v-col cols="9" class="my-auto py-0">
                    <div class="text-subtitle-2">Layanan Cepat</div>
                    <div class="text-caption">Pemesanan dan Pengiriman dalam 1 hari</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
                <v-row>
                  <v-col cols="3" class="my-auto py-0">
                    <v-img src="/assets/icons/transaksi-aman-icon.svg"></v-img>
                  </v-col>
                  <v-col cols="9" class="my-auto py-0">
                    <div class="text-subtitle-2">Transaksi Aman</div>
                    <div class="text-caption">Jaminan Keamanan dalam Bertransaksi</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
                <v-row>
                  <v-col cols="3" class="my-auto py-0">
                    <v-img src="/assets/icons/garansi-icon.svg"></v-img>
                  </v-col>
                  <v-col cols="9" class="my-auto py-0">
                    <div class="text-subtitle-2">Garansi</div>
                    <div class="text-caption">100% Produk Bermutu Dan Berkualitas</div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </div>-->
      <!-- <div class="pt-5"></div>
      <div class="pt-5"></div> -->
      <div class="pt-5" v-show="false">
        <div class="pl-sm-5 text-body-1 text-sm-h6 text-uppercase black--text">
          Produk Eksklusif
        </div>
      </div>
      <div class="py-5" v-show="false">
        <v-card elevation="0" class="rounded-lg bg-eksklusif-product">
          <!-- <v-card elevation="0" class="rounded-lg"> -->
          <v-row class="px-3">
            <v-col cols="12" sm="5" md="4" class="mt-5 mt-sm-auto">
              <div class="py-5 py-sm-0">
                <div class="py-5 py-sm-0"></div>
              </div>
              <v-carousel
                dark
                cycle
                height="400"
                hide-delimiter-background
                :show-arrows="false"
                class="rounded-lg"
              >
                <v-carousel-item
                  v-for="(eksklusif, i) in slidesEksklusif"
                  :key="i"
                >
                  <v-sheet class="bg-transparent">
                    <v-row class="fill-height" align="center" justify="center">
                      <v-col cols="12" class="text-center">
                        <div class="text-body-1 text-sm-h5 text-capitalize">
                          Siap Layani 24 Jam!
                        </div>
                        <div
                          class="text-body-1 text-sm-h5 text-capitalize pb-3 font-weight-bold"
                        >
                          Di Masa Pandemi
                        </div>
                        <div
                          class="text-body-1 text-sm-h5 text-capitalize pt-3"
                        >
                          Terpercaya &amp; Aman
                        </div>
                        <div
                          class="text-body-1 text-sm-h5 text-capitalize pb-5"
                        >
                          Kirim ke Alamat
                        </div>
                        <v-img
                          width="300"
                          :src="eksklusif"
                          class="mt-5 mx-auto"
                        ></v-img>
                        <div class="pt-5"></div>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </v-col>
            <v-col cols="12" sm="7" md="8" id="produkCarousel">
              <v-layout v-resize="onResize" column>
                <carousel
                  :loop="false"
                  :items="4"
                  :nav="false"
                  :dots="false"
                  :margin="20"
                  :responsive="{
                    0: { items: 2 },
                    481: { items: 3 },
                    1264: { items: 4 },
                  }"
                  v-if="productInternal.length > 0"
                >
                  <template v-if="!isMobile">
                    <div
                      v-for="index in Math.ceil(
                        productInternalPagination.total_data / 2
                      )"
                      :key="index"
                      id="produkCarouselItems"
                    >
                      <v-card
                        outlined
                        light
                        class="rounded-lg text-body-2"
                        height="265"
                        v-if="productInternal[(index - 1) * 2]"
                      >
                        <router-link
                          class="text-deco"
                          :to="{
                            name: 'exclusive-product',
                            params: {
                              slug: productInternal[(index - 1) * 2]
                                .product_slug_name,
                              id: productInternal[(index - 1) * 2].product_id,
                            },
                          }"
                        >
                          <v-col class="text-center">
                            <div class="d-flex align-center">
                              <div class="icon-exclusive">
                                <!-- <v-img width="55" src="/assets/icons/logo-pasaroa-green.svg"></v-img> -->
                              </div>
                              <div
                                class="internal-type black--text font-weight-bold font-size-12"
                              >
                                <span
                                  v-if="
                                    (productInternal[(index - 1) * 2]
                                      .product_internal_type == 'aktivasi' ||
                                      productInternal[(index - 1) * 2]
                                        .product_internal_type ==
                                        'aktivasi_upgrade') &&
                                    networkID == 0
                                  "
                                  >Aktivasi</span
                                >
                                <span
                                  v-else-if="
                                    (productInternal[(index - 1) * 2]
                                      .product_internal_type == 'upgrade' ||
                                      productInternal[(index - 1) * 2]
                                        .product_internal_type ==
                                        'aktivasi_upgrade') &&
                                    networkID > 0
                                  "
                                  >Upgrade</span
                                >
                                <span
                                  v-else-if="
                                    productInternal[(index - 1) * 2]
                                      .product_internal_type == 'ro'
                                  "
                                  >RO</span
                                >
                                <span v-else></span>
                              </div>
                            </div>
                            <div class="pt-4">
                              <div class="box-product-img">
                                <v-img
                                  width="150"
                                  class="mx-auto"
                                  :src="
                                    productInternal[(index - 1) * 2]
                                      .product_image[0]
                                      ? productInternal[(index - 1) * 2]
                                          .product_image[0]
                                      : '/assets/product/default.png'
                                  "
                                ></v-img>
                              </div>
                              <div class="pt-3 text-capitalize black--text">
                                {{
                                  productInternal[(index - 1) * 2].product_name
                                }}
                              </div>
                            </div>
                          </v-col>
                        </router-link>
                      </v-card>
                      <v-card
                        outlined
                        light
                        class="mt-5 rounded-lg text-body-2"
                        height="265"
                        v-if="productInternal[(index - 1) * 2 + 1]"
                      >
                        <router-link
                          class="text-deco"
                          :to="{
                            name: 'exclusive-product',
                            params: {
                              slug: productInternal[(index - 1) * 2 + 1]
                                .product_slug_name,
                              id: productInternal[(index - 1) * 2 + 1]
                                .product_id,
                            },
                          }"
                        >
                          <v-col class="text-center">
                            <div class="d-flex align-center">
                              <div class="icon-exclusive">
                                <!-- <v-img width="55" src="/assets/icons/logo-pasaroa-green.svg"></v-img> -->
                              </div>
                              <div
                                class="internal-type black--text font-weight-bold font-size-12"
                              >
                                <span
                                  v-if="
                                    (productInternal[(index - 1) * 2 + 1]
                                      .product_internal_type == 'aktivasi' ||
                                      productInternal[(index - 1) * 2 + 1]
                                        .product_internal_type ==
                                        'aktivasi_upgrade') &&
                                    networkID == 0
                                  "
                                  >Aktivasi</span
                                >
                                <span
                                  v-else-if="
                                    (productInternal[(index - 1) * 2 + 1]
                                      .product_internal_type == 'upgrade' ||
                                      productInternal[(index - 1) * 2 + 1]
                                        .product_internal_type ==
                                        'aktivasi_upgrade') &&
                                    networkID > 0
                                  "
                                  >Upgrade</span
                                >
                                <span
                                  v-else-if="
                                    productInternal[(index - 1) * 2 + 1]
                                      .product_internal_type == 'ro'
                                  "
                                  >RO</span
                                >
                                <span v-else></span>
                              </div>
                            </div>
                            <div class="pt-4">
                              <div class="box-product-img">
                                <v-img
                                  width="150"
                                  class="mx-auto"
                                  :src="
                                    productInternal[(index - 1) * 2 + 1]
                                      .product_image[0]
                                      ? productInternal[(index - 1) * 2 + 1]
                                          .product_image[0]
                                      : '/assets/product/default.png'
                                  "
                                ></v-img>
                              </div>
                              <div class="pt-3 text-capitalize black--text">
                                {{
                                  productInternal[(index - 1) * 2 + 1]
                                    .product_name
                                }}
                              </div>
                            </div>
                          </v-col>
                        </router-link>
                      </v-card>
                    </div>
                  </template>

                  <template v-if="isMobile">
                    <template v-if="productInternal.length > 4">
                      <div
                        v-for="index in Math.ceil(
                          productInternalPagination.total_data / 2
                        )"
                        :key="index"
                        id="produkCarouselItems"
                      >
                        <v-card
                          outlined
                          light
                          class="rounded-lg text-body-2"
                          height="265"
                          v-if="productInternal[(index - 1) * 2]"
                        >
                          <router-link
                            class="text-deco"
                            :to="{
                              name: 'exclusive-product',
                              params: {
                                slug: productInternal[(index - 1) * 2]
                                  .product_slug_name,
                                id: productInternal[(index - 1) * 2].product_id,
                              },
                            }"
                          >
                            <v-col class="text-center">
                              <div class="d-flex align-center">
                                <div class="icon-exclusive">
                                  <!-- <v-img width="65" src="/assets/icons/logo-pasaroa-green.svg"></v-img> -->
                                </div>
                                <div
                                  class="internal-type black--text font-weight-bold font-size-12"
                                >
                                  <span
                                    v-if="
                                      productInternal[(index - 1) * 2]
                                        .product_internal_type == 'aktivasi' &&
                                      networkID == 0
                                    "
                                    >Aktivasi</span
                                  >
                                  <span
                                    v-else-if="
                                      networkID > 0 &&
                                      productInternal[(index - 1) * 2]
                                        .product_internal_type == 'aktivasi'
                                    "
                                    >Upgrade</span
                                  >
                                  <span
                                    v-else-if="
                                      productInternal[(index - 1) * 2]
                                        .product_internal_type == 'ro'
                                    "
                                    >RO</span
                                  >
                                  <span v-else></span>
                                </div>
                              </div>
                              <div class="pt-4">
                                <div class="box-product-img">
                                  <v-img
                                    width="150"
                                    class="mx-auto"
                                    :src="
                                      productInternal[(index - 1) * 2]
                                        .product_image[0]
                                        ? productInternal[(index - 1) * 2]
                                            .product_image[0]
                                        : '/assets/product/default.png'
                                    "
                                  ></v-img>
                                </div>
                                <div class="pt-3 text-capitalize black--text">
                                  {{
                                    productInternal[(index - 1) * 2]
                                      .product_name
                                  }}
                                </div>
                              </div>
                            </v-col>
                          </router-link>
                        </v-card>
                        <v-card
                          outlined
                          light
                          class="mt-5 rounded-lg text-body-2"
                          height="265"
                          v-if="productInternal[(index - 1) * 2 + 1]"
                        >
                          <router-link
                            class="text-deco"
                            :to="{
                              name: 'exclusive-product',
                              params: {
                                slug: productInternal[(index - 1) * 2 + 1]
                                  .product_slug_name,
                                id: productInternal[(index - 1) * 2 + 1]
                                  .product_id,
                              },
                            }"
                          >
                            <v-col class="text-center">
                              <div class="d-flex align-center">
                                <div class="icon-exclusive">
                                  <v-img
                                    width="65"
                                    src="/assets/icons/logo-pasaroa-green.svg"
                                  ></v-img>
                                </div>
                                <div
                                  class="internal-type black--text font-weight-bold font-size-12"
                                >
                                  <span
                                    v-if="
                                      productInternal[(index - 1) * 2 + 1]
                                        .product_internal_type == 'aktivasi' &&
                                      networkID == 0
                                    "
                                    >Aktivasi</span
                                  >
                                  <span
                                    v-else-if="
                                      networkID > 0 &&
                                      productInternal[(index - 1) * 2 + 1]
                                        .product_internal_type == 'aktivasi'
                                    "
                                    >Upgrade</span
                                  >
                                  <span
                                    v-else-if="
                                      productInternal[(index - 1) * 2 + 1]
                                        .product_internal_type == 'ro'
                                    "
                                    >RO</span
                                  >
                                  <span v-else></span>
                                </div>
                              </div>
                              <div class="pt-4">
                                <div class="box-product-img">
                                  <v-img
                                    width="150"
                                    class="mx-auto"
                                    :src="
                                      productInternal[(index - 1) * 2 + 1]
                                        .product_image[0]
                                        ? productInternal[(index - 1) * 2 + 1]
                                            .product_image[0]
                                        : '/assets/product/default.png'
                                    "
                                  ></v-img>
                                </div>
                                <div class="pt-3 text-capitalize black--text">
                                  {{
                                    productInternal[(index - 1) * 2 + 1]
                                      .product_name
                                  }}
                                </div>
                              </div>
                            </v-col>
                          </router-link>
                        </v-card>
                      </div>
                    </template>

                    <template v-else>
                      <div
                        v-for="(productInt, index) in productInternal"
                        :key="index"
                        id="produkCarouselItems"
                      >
                        <v-card
                          outlined
                          light
                          class="rounded-lg text-body-2"
                          height="265"
                        >
                          <router-link
                            class="text-deco"
                            :to="{
                              name: 'exclusive-product',
                              params: {
                                slug: productInt.product_slug_name,
                                id: productInt.product_id,
                              },
                            }"
                          >
                            <v-col class="text-center">
                              <div class="d-flex align-center">
                                <div class="icon-exclusive">
                                  <!-- <v-img width="65" src="/assets/icons/logo-pasaroa-green.svg"></v-img> -->
                                </div>
                                <div
                                  class="internal-type black--text font-weight-bold font-size-12"
                                >
                                  <span
                                    v-if="
                                      productInt.product_internal_type ==
                                        'aktivasi' && networkID == 0
                                    "
                                    >Aktivasi</span
                                  >
                                  <span
                                    v-else-if="
                                      networkID > 0 &&
                                      productInt.product_internal_type ==
                                        'aktivasi'
                                    "
                                    >Upgrade</span
                                  >
                                  <span
                                    v-else-if="
                                      productInt.product_internal_type == 'ro'
                                    "
                                    >RO</span
                                  >
                                  <span v-else></span>
                                </div>
                              </div>
                              <div class="pt-4">
                                <div class="box-product-img">
                                  <v-img
                                    width="150"
                                    class="mx-auto"
                                    :src="
                                      productInt.product_image[0]
                                        ? productInt.product_image[0]
                                        : '/assets/product/default.png'
                                    "
                                  ></v-img>
                                </div>
                                <div class="pt-3 text-capitalize black--text">
                                  {{ productInt.product_name }}
                                </div>
                              </div>
                            </v-col>
                          </router-link>
                        </v-card>
                      </div>
                    </template>
                  </template>

                  <template slot="prev">
                    <v-card
                      elevation="0"
                      class="col-12 pa-0"
                      v-if="productInternal.length > limitNav"
                    >
                      <v-btn
                        x-small
                        color="white"
                        elevation="3"
                        fab
                        class="prev prev-eksklusif"
                      >
                        <v-icon color="grey darken-1">mdi-chevron-left</v-icon>
                      </v-btn>
                    </v-card>
                  </template>
                  <template slot="next">
                    <v-card
                      elevation="0"
                      class="col-12 pa-0"
                      v-if="productInternal.length > limitNav"
                    >
                      <v-btn
                        x-small
                        color="white"
                        elevation="3"
                        fab
                        class="next next-eksklusif"
                      >
                        <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
                      </v-btn>
                    </v-card>
                  </template>
                </carousel>
              </v-layout>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div class="pt-5" v-if="false">
        <div class="pl-sm-5 text-body-1 text-sm-h6 text-uppercase black--text">
          Store Partner
        </div>
      </div>
      <div class="py-5" v-if="false">
        <v-card elevation="0" class="rounded-lg bg-eksklusif-partner">
          <v-row class="px-3">
            <v-col cols="12" sm="5" md="4" class="my-auto">
              <v-row class="fill-height" align="center" justify="center">
                <v-col cols="12" class="text-center">
                  <div
                    class="text-body-1 black--text text-sm-h6 font-weight-bold text-capitalize"
                  >
                    Belanja di Store Partner
                  </div>
                  <div align="center" justify="center" class="pt-2 pb-2">
                    <v-img
                      v-if="window.innerWidth < 481"
                      width="30%"
                      src="/assets/background/partner-moto.png"
                    ></v-img>
                    <v-img
                      v-else-if="
                        window.innerWidth > 480 && window.innerWidth < 769
                      "
                      width="35%"
                      src="/assets/background/partner-moto.png"
                    ></v-img>
                    <v-img
                      v-else
                      width="60%"
                      src="/assets/background/partner-moto.png"
                    ></v-img>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="7" md="8" id="storeCarousel">
              <v-layout v-resize="onResize" column>
                <carousel
                  :loop="false"
                  :items="4"
                  :nav="false"
                  :dots="false"
                  :margin="20"
                  :responsive="{
                    0: { items: 2 },
                    481: { items: 3 },
                    1264: { items: 4 },
                  }"
                  v-if="store.length > 0"
                >
                  <template>
                    <div
                      v-for="(data, index) in store"
                      :key="index"
                      id="partnerCarouselItems"
                    >
                      <v-card
                        outlined
                        light
                        class="rounded-lg text-body-2"
                        :height="isMobile ? '300' : '340'"
                      >
                        <router-link
                          class="text-deco"
                          :to="{
                            name: 'store-detail',
                            params: { slug: data.store_slug },
                          }"
                        >
                          <v-col class="text-center">
                            <div class="pt-4">
                              <div class="box-product-img">
                                <v-img
                                  width="150"
                                  class="mx-auto"
                                  :src="
                                    data.store_image
                                      ? data.store_image
                                      : '/assets/seller/default-toko.svg'
                                  "
                                ></v-img>
                              </div>
                              <div class="pt-3 text-capitalize black--text">
                                {{ data.store_name }}
                              </div>
                              <div
                                class="pt-1 pt-md-3 black--text font-size-xs-11"
                              >
                                {{ data.store_description }}
                              </div>
                            </div>
                          </v-col>
                        </router-link>
                      </v-card>
                    </div>
                  </template>

                  <!-- 									<template v-show="isMobile">
										<div v-for="(data, index) in store" :key="index" id="partnerCarouselItems">
											<v-card outlined light class="rounded-lg text-body-2" height="265">
												<router-link class="text-deco" :to="{ name: 'store-detail', params: { slug: data.store_slug } }">
													<v-col class="text-center">
														<div class="pt-4">
															<div class="box-product-img">
																<v-img width="150" class="mx-auto" :src="data.store_image ? data.store_image : '/assets/seller/default-toko.svg'"></v-img>
															</div>
															<div class="pt-3 text-capitalize black--text">{{ data.store_name }}</div>
															<div class="pt-3 black--text">{{ data.store_description }}</div>
														</div>
													</v-col>
												</router-link>
											</v-card>
										</div>
                  </template>-->

                  <template slot="prev">
                    <v-card
                      elevation="0"
                      class="col-12 pa-0"
                      v-if="store.length > limitStore"
                    >
                      <v-btn
                        x-small
                        color="white"
                        elevation="3"
                        fab
                        class="prev prev-store-partner"
                      >
                        <v-icon color="grey darken-1">mdi-chevron-left</v-icon>
                      </v-btn>
                    </v-card>
                  </template>
                  <template slot="next">
                    <v-card
                      elevation="0"
                      class="col-12 pa-0"
                      v-if="store.length > limitStore"
                    >
                      <v-btn
                        x-small
                        color="white"
                        elevation="3"
                        fab
                        class="next next-store-partner"
                      >
                        <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
                      </v-btn>
                    </v-card>
                  </template>
                </carousel>
                <div class="text-right text-uppercase pt-5">
                  <!-- <v-btn @click="searchPartnerStore" large color="teal darken-4" class="rounded-lg text-capitalize white--text" width="200" :loading="loadingProcess">Lihat Lainnya</v-btn> -->
                  <span
                    @click="searchPartnerStore"
                    class="white--text darken-4 font-weight-bold"
                    >Lihat Lainnya >></span
                  >
                </div>
              </v-layout>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div class>
        <category />
      </div>
      <div class="pt-5">
        <div class="pl-sm-5 text-body-1 text-sm-h6 text-uppercase font-weight-black black--text">
          Paling Banyak Dicari
        </div>
      </div>
      <div class="pt-4 pb-5">
        <v-row>
          <v-col class="py-0" v-if="productMostViewed.length > 0">
            <carousel
              :loop="false"
              :nav="false"
              :dots="false"
              :margin="20"
              :responsive="{
                0: { items: 1 },
                600: { items: 2 },
                1000: { items: 3 },
              }"
            >
              <div
                class
                v-for="item in productMostViewed"
                :key="item.product_id"
              >
                <router-link
                  class="text-deco"
                  :to="{
                    name: 'product-detail',
                    params: {
                      slug: item.product_slug_name,
                      id: item.product_id,
                    },
                  }"
                >
                  <v-card class="rounded-lg border-yellow" outlined>
                    <v-row class="pl-3">
                      <v-col cols="4">
                        <v-img
                          height="100"
                          width="100%"
                          class="rounded-lg"
                          :src="
                            item.product_image[0]
                              ? item.product_image[0]
                              : '/assets/product/default.png'
                          "
                        ></v-img>
                      </v-col>
                      <v-col cols="8" class="my-auto">
                        <div class="grey--text text--darken-2">
                          {{ item.product_name }}
                        </div>
                        <div class="grey--text">
                          {{ item.product_view_count }} dicari
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </router-link>
              </div>
              <template slot="prev">
                <v-card elevation="0" class="col-12 pa-0">
                  <v-btn
                    x-small
                    color="white"
                    elevation="3"
                    fab
                    class="prev prev-most-search"
                  >
                    <v-icon color="grey darken-1">mdi-chevron-left</v-icon>
                  </v-btn>
                </v-card>
              </template>
              <template slot="next">
                <v-card elevation="0" class="col-12 pa-0">
                  <v-btn
                    x-small
                    color="white"
                    elevation="3"
                    fab
                    class="next next-most-search"
                  >
                    <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
                  </v-btn>
                </v-card>
              </template>
            </carousel>
          </v-col>
        </v-row>
      </div>
      <template v-if="bannerList.length">
        <template v-for="(row, idx) in bannerList">
          <div :key="idx">
            <div class="pt-5">
              <div
                class="pl-sm-5 text-body-1 text-sm-h6 text-uppercase black--text"
              >
                {{ row.banner_name }}
              </div>
            </div>
            <div class="pt-4 pb-5">
              <a :href="row.banner_url">
                <v-img :src="row.banner_image"></v-img>
              </a>
            </div>
          </div>
        </template>
      </template>
      <div class="pt-5">
        <div class="pl-sm-5 text-body-1 text-sm-h6 text-uppercase black--text font-weight-black">
          Produk Terlaris
        </div>
      </div>
      <div class="pt-4 pb-5" v-if="productMostBuy.length > 0">
        <carousel
          :loop="false"
          :nav="false"
          :dots="false"
          :margin="20"
          :responsive="{
            0: { items: 2 },
            600: { items: 3 },
            1000: { items: 6 },
          }"
        >
          <div class v-for="item in productMostBuy" :key="item.product_id">
            <router-link
              class="text-deco"
              :to="{
                name: 'product-detail',
                params: { slug: item.product_slug_name, id: item.product_id },
              }"
            >
              <v-card class="rounded-lg border-yellow" outlined height="170">
                <div class="mt-3">
                  <v-img
                    width="100"
                    height="100"
                    class="rounded-lg mx-auto"
                    :src="
                      item.product_image[0]
                        ? item.product_image[0]
                        : '/assets/product/default.png'
                    "
                  ></v-img>
                  <div
                    class="pt-2 text-body-2 text-center black--text font-weight-bold product-name-most"
                  >
                    {{ item.product_name }}
                  </div>
                </div>
              </v-card>
            </router-link>
          </div>
          <template slot="prev">
            <v-card elevation="0" class="col-12 pa-0">
              <v-btn
                x-small
                color="white"
                elevation="3"
                fab
                class="prev prev-best-selling"
              >
                <v-icon color="grey darken-1">mdi-chevron-left</v-icon>
              </v-btn>
            </v-card>
          </template>
          <template slot="next">
            <v-card elevation="0" class="col-12 pa-0">
              <v-btn
                x-small
                color="white"
                elevation="3"
                fab
                class="next next-best-selling"
              >
                <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
              </v-btn>
            </v-card>
          </template>
        </carousel>
      </div>
      <div class="pt-5">
        <div class="pl-sm-5 text-body-1 text-sm-h6 text-uppercase black--text font-weight-black">
          Rekomendasi Produk
        </div>
        <!-- <v-tabs class="no-slider" color="black">
          <v-tab class="px-0 px-sm-5 text-body-1 text-sm-h6"
            >Rekomendasi Produk</v-tab
          >
          <v-tab class="px-0 px-sm-5 text-body-1 text-sm-h6" v-if="false"
            >Promo</v-tab
          >
        </v-tabs> -->
      </div>
      <div class="pt-5">
        <v-row class="ml-0" v-if="productExternal.length > 0">
          <v-col
            class="pl-0 pt-0"
            cols="6"
            sm="3"
            md="2"
            v-for="product in productExternal"
            :key="`${product.product_code} ${product.product_id}`"
          >
            <v-hover v-slot:default="{ hover }">
              <product-card :product="product" :hover="hover"/> 
            </v-hover>
          </v-col>
        </v-row>
      </div>
      <div class="pt-3 text-center" v-if="productExternalPagination.next > 0">
        <v-btn
          @click="
            loadMoreProductEx({
              page: productExternalPagination.current + 1,
              limit: 12,
            })
          "
          large
          outlined
          color="#ffb215"
          class="rounded-lg text-capitalize black--text border-yellow rounded-pill"
          width="200"
          :loading="loadingProcess"
          >Lihat Lainnya</v-btn
        >
      </div>
    </v-col>
    <v-col>
      <div class="py-5">
        <v-card elevation="0" light class="rounded-lg bg-dark white--text">
          <v-col cols="12">
            <p class="text-center">
              Platform Komunitas Bisnis Reseller Dropship Online, Supplier
              Grosir, serta belajar banyak hal positif yang dapat meningkatkan
              bisnis Anda.
            </p>
            <v-row>
              <v-col class="d-block d-md-none" cols="12">
                <v-carousel
                  cycle
                  :progress="true"
                  hide-delimiters
                  hide-delimiter-background
                  :show-arrows="false"
                  class="rounded-lg slider-h-100"
                >
                  <template v-slot:prev="{ on, attrs }">
                    <v-btn color="success" v-bind="attrs" v-on="on"
                      >Previous slide</v-btn
                    >
                  </template>
                  <template v-slot:next="{ on, attrs }">
                    <v-btn color="info" v-bind="attrs" v-on="on"
                      >Next slide</v-btn
                    >
                  </template>
                  <v-carousel-item
                    v-for="(list, index) in tagList"
                    :key="index"
                  >
                    <v-row class="white--text">
                      <v-col sm="4" cols="5" class="my-auto py-0">
                        <v-img :src="list.src"></v-img>
                      </v-col>
                      <v-col sm="8" cols="7" class="my-auto py-0 text-left">
                        <div class="text-subtitle-2">{{ list.title }}</div>
                        <div class="text-caption">{{ list.caption }}</div>
                      </v-col>
                    </v-row>
                  </v-carousel-item>
                </v-carousel>
              </v-col>
              <v-col
                v-for="(list, index) in tagList"
                :key="index"
                cols="12"
                sm="6"
                md="3"
                class="py-sm-1 py-md-0 d-none d-md-block"
              >
                <v-row>
                  <v-col cols="3" class="my-auto py-0">
                    <v-img :src="list.src"></v-img>
                  </v-col>
                  <v-col cols="9" class="my-auto py-0">
                    <div class="text-subtitle-2">{{ list.title }}</div>
                    <div class="text-caption">{{ list.caption }}</div>
                  </v-col>
                </v-row>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
                <v-row>
                  <v-col cols="3" class="my-auto py-0">
                    <v-img src="/assets/icons/layanan-cepat-icon.svg"></v-img>
                  </v-col>
                  <v-col cols="9" class="my-auto py-0">
                    <div class="text-subtitle-2">Layanan Cepat</div>
                    <div class="text-caption">Pemesanan dan Pengiriman dalam 1 hari</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
                <v-row>
                  <v-col cols="3" class="my-auto py-0">
                    <v-img src="/assets/icons/transaksi-aman-icon.svg"></v-img>
                  </v-col>
                  <v-col cols="9" class="my-auto py-0">
                    <div class="text-subtitle-2">Transaksi Aman</div>
                    <div class="text-caption">Jaminan Keamanan dalam Bertransaksi</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-sm-1 py-md-0">
                <v-row>
                  <v-col cols="3" class="my-auto py-0">
                    <v-img src="/assets/icons/garansi-icon.svg"></v-img>
                  </v-col>
                  <v-col cols="9" class="my-auto py-0">
                    <div class="text-subtitle-2">Garansi</div>
                    <div class="text-caption">100% Produk Bermutu Dan Berkualitas</div>
                  </v-col>
                </v-row>
              </v-col>-->
            </v-row>
          </v-col>
        </v-card>
      </div>
    </v-col>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import { mapActions, mapState, mapMutations } from "vuex";
import authHelper from "@/helpers/auth";
import Category from "../../../components/category.vue";
import saldoPreviewVue from "../../../components/saldoPreview.vue";
import productCard from "../../../components/productCard.vue";
export default {
  name: "Home",
  components: {
    carousel,
    Category,
    'product-card' : productCard,
    "saldo-preview": saldoPreviewVue,
  },
  data() {
    return {
      bannerList: [],
      loadingProcess: false,
      isMobile: false,
      limitNav: 8,
      tagList: [
        {
          title: "Layanan 24/7",
          caption: "Tim Support Handal dan Cepat untuk Anda",
          src: "/assets/icons/layanan-24-jam-icon.svg",
        },
        {
          title: "Layanan Cepat",
          caption: "Pemesanan dan Pengiriman dalam 1 hari",
          src: "/assets/icons/layanan-cepat-icon.svg",
        },
        {
          title: "Transaksi Aman",
          caption: "Jaminan Keamanan dalam Bertransaksi",
          src: "/assets/icons/transaksi-aman-icon.svg",
        },
        {
          title: "Garansi",
          caption: "100% Produk Bermutu Dan Berkualitas",
          src: "/assets/icons/garansi-icon.svg",
        },
      ],
      limitStore: 4,
      slides: [
        // "/assets/banner/banner-1.png"
        "/assets/banner/banner-1.png",
        // "/assets/banner/banner-2.png"
        // ""
      ],
      slidesEksklusif: [
        "/assets/background/herbal-image.png",
        "/assets/background/herbal-image.png",
      ],
    };
  },
  computed: {
    ...mapState("auth", ["isAuth", "userData", "accountList"]),
    ...mapState("productExternal", [
      "productInternal",
      "productInternalPagination",
      "productExternal",
      "productExternalPagination",
      "productMostViewed",
      "productMostViewedPagination",
      "productMostBuy",
      "productMostBuyPagination",
    ]),
    ...mapState("store", ["store", "storePagination"]),
    ...mapState("banner", ["banner", "bannerPagination", "loadBanner"]),
    ...mapState("auth", ["userData"]),

    window() {
      return window;
    },

    networkID() {
      let dataUser = {
        user_network_id: 0,
      };
      if (this.userData) {
        dataUser = this.userData;
      }
      return dataUser.user_network_id;
    },
  },
  methods: {
    ...mapActions("productExternal", [
      "getProductInternal",
      "getProductExternal",
      "getMoreProductExternal",
      "getProductMostBuy",
      "getProductMostViewed",
    ]),
    ...mapActions("store", ["getStore"]),
    ...mapActions("banner", ["getBanner", "getBannerRaw"]),
    ...mapMutations("productExternal", ["clearProductExternal"]),
    ...mapMutations("store", ["setStore"]),

    searchPartnerStore() {
      this.$router.push({
        name: "search",
        query: { type: "store", is_partner: true },
      });
    },
    async loadMoreProductEx(params) {
      this.loadingProcess = await true;
      this.getMoreProductExternal(params)
        .then(() => {
          this.loadingProcess = false;
        })
        .catch(() => {
          this.loadingProcess = false;
        });
    },

    redirectTo(url) {
      location.replace(url);
    },

    onResize() {
      if (window.innerWidth < 481) {
        this.isMobile = true;
        this.limitNav = 4;
        this.limitStore = 2;
      } else if (window.innerWidth > 480 && window.innerWidth < 769) {
        this.isMobile = true;
        this.limitNav = 6;
        this.limitStore = 3;
      } else {
        this.isMobile = false;
        this.limitNav = 8;
        this.limitStore = 4;
      }
    },
  },
  created() {
    this.setStore({ data: [], pagination: {} });
    this.$store.dispatch("setPageTitle", `Beranda`);
    this.getProductInternal({ limit: 100 });
    this.getBanner({ banner_position: "home_slider" });
    this.getBannerRaw({
      banner_position: "home_banner",
      limit: 1,
    }).then((res) => {
      // console.log("ressss", res);
      this.bannerList = res;
    });
    this.getProductMostViewed({ limit: 12 });
    this.getProductMostBuy({ limit: 12 });
    this.getProductExternal({ limit: 12 });
    this.getStore(
      this.queryString({
        limit: 10,
        page: 1,
        params: [
          {
            value: "true",
            comparison: "like",
            type: "string",
            field: "store_is_b2b",
          },
        ],
        sort: "store_rating",
        dir: "DESC",
      })
    );
    let referral = this.$route.params.referral;
    if (referral) {
      authHelper.setReferal(referral);
      this.$router.push({
        name: "home",
      });
    }
  },
  beforeDestroy() {
    this.clearProductExternal();
  },
};
</script>

<style lang="scss">
.box-product-img {
  display: flex;
  align-items: center;
  height: 155px;
}
</style>
